import { BodyZone, CatalogShop, PiercingTypeEntity } from '@digitaltattoo/types';
import { fetchJSON } from './http';

type BodyZonesResponse = { success: boolean; data: { bodyZones: BodyZone[] } };
type PiercingTypesResponse = { success: boolean; data: { piercingTypes: PiercingTypeEntity[] } };
type ShopsResponse = { success: boolean; data: { shops: CatalogShop[] } };

export const catalogApi = {
  fetchBodyZones(): Promise<BodyZonesResponse> {
    return fetchJSON('/api/clients/body-zones/active');
  },
  fetchPiercingTypes(bodyZoneId: string): Promise<PiercingTypesResponse> {
    return fetchJSON(`/api/clients/piercing-types/active?bodyZoneId=${encodeURIComponent(bodyZoneId)}`);
  },
  fetchShops(piercingTypeId: string): Promise<ShopsResponse> {
    return fetchJSON(`/api/clients/shops/active?piercingTypeId=${encodeURIComponent(piercingTypeId)}`);
  },
};


